import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/purchases`
};


function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    create: (data: RequestData) => {
      return HttpRequest.post(getUrl(), data.payload, {});
    },
  
    update: (data: RequestData) => {
      const method = "patch"
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest[method](url, data.payload, {});
    },
    
    getItem: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.get(url);
    },
  
    getStatistics: ({params}: RequestData) => {
      const url = `${getUrl()}/statistics`;
      return HttpRequest.get(url, {
        params
      });
    },
  };
}

export default api();
